<template>
	<campaigns-tooltip-label v-if="taxonomy.name">
		<template v-slot:tooltip><slot name="tooltip">{{ tooltip }}</slot></template>
		<template v-slot:label>
			<span v-if="$slots.label"><slot name="label"></slot></span>
			<span v-else>Show on {{ taxonomy.label }}:</span>
		</template>

		<core-form-multi-select-input
			v-if="multi"
			:name="taxonomy.name"
			@input="handleMultiSelectEmit"
			:value="value"
			:options="options"
			class="text-setting omapi-input"
			:placeholder="`Select ${taxonomy.label}...`"
			:searchPlaceholder="`Type to search for ${taxonomy.label}`"
		/>
		<common-selectable-group
			v-else
			class="text-setting omapi-input"
			type="checkbox"
			:groupName="taxonomy.name"
			:options="options"
			:value="value"
			@input="handleEmit"
		/>

	</campaigns-tooltip-label>
</template>

<script>
import { arraySetter } from '@/utils'
export default {
	props : {
		taxonomy : {
			type     : Object,
			required : true,
		},
		value     : Array,
		multi     : Boolean,
		postTypes : Array,
	},
	computed : {
		tooltip () {
			if (this.$get('postTypes', []).length && this.$get('taxonomy.for', []).length) {
				const types = []
				this.taxonomy.for.forEach(pt => {
					const type = this.postTypes.find(type => type.name === pt)
					if (type) {
						types.push(type.label)
					}
				})

				if (types.length) {
					const joined = 1 < types.length
						? types.splice(0, types.length - 1).join(', ') + ', and ' + types.join(', ')
						: types.join(', ')
					return `${this.taxonomy.label} (${this.taxonomy.name}) is used on the ${joined} post type${1 < types.length ? 's' : ''}.`
				}
			}

			return ''
		},
		options () {
			const transform = t => ({
				value                           : t.term_id ? t.term_id.toString() : '',
				[this.multi ? 'name' : 'label'] : t.name + (this.multi ? (t.term_id ? ` (${t.term_id.toString()})` : '') : ''),
				titleTag                        : `'${t.slug}' term in '${t.taxonomy}' taxonomy`,
			})

			return this.taxonomy.terms.map(transform)
		},
	},
	methods : {
		handleEmit ({ target }) {
			const { name, value } = target
			const newValue =  arraySetter(value, this.value)

			this.$emit('input', {
				name,
				newValue,
			})
		},
		handleMultiSelectEmit (newValue, { name } = {}) {
			this.$emit('input', {
				name,
				newValue,
			})
		},
	},
}
</script>
